module.exports = "<button mat-raised-button (click)=\"openUploadDialog()\">Upload</button>"